/* @flow */
import { adminOptIn } from 'admin/actions/OrgRoleActions';
import AffiliationShape from 'shapes/Affiliation';
import AlertDialog from 'components/AlertDialog.jsx';
import { SchoolCrownBadge } from 'admin/components/AdminVerifiedModal.jsx';
import React from 'react';
import YouTubeEmbed from 'components/YouTubeEmbed.jsx';
import { VIDEO_URL } from 'admin/constants/AdminRoles';

import './styles/AdminVerificationModal.scss';

class AdminNeedsOptInModal extends React.Component {
  static propTypes = {
    affiliation: AffiliationShape.isRequired,
    onRequestHide: React.PropTypes.func.isRequired,
    orgName: React.PropTypes.string.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  acceptAdminship = () => {
    const aff = this.props.affiliation;
    adminOptIn(aff.organization_id, this.props.orgName, aff);
    // Need to allow the modal to be removed before transitioning
    setTimeout(() => {
      this.context.router.push('/organizations/' + aff.organization_id);
    }, 0);
  }

  render() {
    return (
      <AlertDialog
        eventScreenName="AdminNeedsOptInModal"
        ref="dialog"
        size="small"
        className="AdminVerificationModal"
        headerImageComponent={<SchoolCrownBadge />}
        title="Introducing Remind for Schools"
        subtext={`Reach your school instantly with direct, reliable messaging. Get started and
 we'll notify the teachers who use Remind that ${this.props.orgName} has a verified administrator.`}
        buttonText="Get Remind for Schools"
        closeLinkText="Not right now"
        onOkay={this.acceptAdminship}
        onRequestHide={this.props.onRequestHide}>
        <YouTubeEmbed
          className="AdminVerificationModal-video"
          width={392}
          height={220}
          src={VIDEO_URL}
        />
      </AlertDialog>
    );
  }
}

export default AdminNeedsOptInModal;



// WEBPACK FOOTER //
// ./src/admin/components/AdminNeedsOptInModal.jsx